/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
import React, { useContext } from 'react';
import classNames from 'classnames';

import Form from '../Form';
import BundleForm from '../BundleForm';
import Intro from '../Intro';
import {
	Accordion,
	AccordionControl,
	AccordionItem,
	AccordionPanel,
} from '../../Accordion';
import renderIcon from '../../../utils/renderIcon';

import { ProductFormContext } from '../../../context/product-form-context';
import { createMetaFieldsMap } from '../../../utils';
import RichTextShopify from '../../RichTextShopify';

const ns = `product-info`;

const AccordionSection = ({ title, data }) => {
	return (
		<Accordion className={`${ns}__accordion`}>
			<AccordionItem className={`${ns}__accordion-item`}>
				<AccordionControl className={`${ns}__accordion-control`}>
					<p className={`${ns}__accordion-label text-small`}>{title}</p>
					<span className={`${ns}__accordion-icons`} aria-hidden>
						{renderIcon('plus')}
						{renderIcon('minus')}
					</span>
				</AccordionControl>
				<AccordionPanel>
					<RichTextShopify fieldData={data} />
				</AccordionPanel>
			</AccordionItem>
		</Accordion>
	);
};

const PDPInfo = ({ product, globalSettings }) => {
	const normalizedCustomFields = ({ custom }) => {
		if (!custom) return {};

		const {
			_includes_section_title,
			_includes_section,
			_key_features_section_title,
			_key_features_section
		} = custom;

		return {
			includesSectionTitle: _includes_section_title,
			includesSection: _includes_section,
			keyFeaturesSectionTitle: _key_features_section_title,
			keyFeaturesSection: _key_features_section,
		};
	};

	const { variant, isBundle } = useContext(ProductFormContext);
	const { descriptionHtml, metafields } = product;
	const {
		includesSectionTitle,
		includesSection,
		keyFeaturesSectionTitle,
		keyFeaturesSection
	} = normalizedCustomFields(
		createMetaFieldsMap(metafields)
	);

	const rootClassnames = classNames({ [`${ns}`]: true });

	return (
		<div className={rootClassnames}>
			<div className={`${ns}__heading`}>
				<Intro product={product} variant={variant} />
			</div>
			<div className={`${ns}__description`}>
				{descriptionHtml && (
					<div
						className={`${ns}__description-text`}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html: descriptionHtml }}
					/>
				)}

				{(includesSection || keyFeaturesSection) && (
					<div className={`${ns}__accordions`}>
						{includesSection && (
							<AccordionSection title={includesSectionTitle || 'Includes'} data={includesSection} />
						)}
						{keyFeaturesSection && (
							<AccordionSection
								title={keyFeaturesSectionTitle || 'Key Features'}
								data={keyFeaturesSection}
							/>
						)}
					</div>
				)}
			</div>
			<div className={`${ns}__form`}>
				{isBundle() ? (
					<BundleForm
						variant={variant}
						product={product}
						globalSettings={globalSettings}
					/>
				) : (
					<Form
						variant={variant}
						product={product}
						globalSettings={globalSettings}
					/>
				)}
			</div>
		</div>
	);
};

export default PDPInfo;
